/**
 * Estrutura previsivel enquanto a PRIMEIRA consulta carrega (contrato `Skeleton` do catalogo).
 *
 * PROMOVIVEL: sao blocos, nao texto falso - a regra do catalogo e "imita blocos, nao texto falso
 * detalhado". O que este componente promete e a FORMA do que vem, para a pagina nao saltar quando
 * o conteudo chegar.
 *
 * Nao usar em atualizacao de conteudo ja visivel: ai a regra e o contrario ("loading nunca apaga
 * conteudo estavel"), e quem serve e o `Spinner` sobre o conteudo que fica.
 *
 * SEGUNDA COPIA (a primeira e do New Inteli Graph). Copiado, e nao reescrito, de proposito: os dois
 * apps precisam da mesma peca e o design system ainda nao a exporta. **Na terceira copia, sobe para
 * `@ledger-glass/react`** - tres implementacoes da mesma coisa divergem, duas ainda se mantem em dia.
 */

export function Skeleton({ height, width = '100%' }: { height: number | string; width?: number | string }) {
  return <span className="skeleton" style={{ height, width }} aria-hidden="true" />
}
